// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/assets/v1/delete_set_dressing_reference.proto (package protos.vision.assets.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/assets/v1/delete_set_dressing_reference.proto.
 */
export const file_vision_assets_v1_delete_set_dressing_reference: GenFile = /*@__PURE__*/
  fileDesc("CjR2aXNpb24vYXNzZXRzL3YxL2RlbGV0ZV9zZXRfZHJlc3NpbmdfcmVmZXJlbmNlLnByb3RvEhdwcm90b3MudmlzaW9uLmFzc2V0cy52MSKmAQohRGVsZXRlU2V0RHJlc3NpbmdSZWZlcmVuY2VSZXF1ZXN0ElEKBnBhcmFtcxgBIAEoCzJBLnByb3Rvcy52aXNpb24uYXNzZXRzLnYxLkRlbGV0ZVNldERyZXNzaW5nUmVmZXJlbmNlUmVxdWVzdC5QYXJhbXMaLgoGUGFyYW1zEhIKCnByb2plY3RfaWQYASABKAkSEAoIYXNzZXRfaWQYAiABKAkiggEKIkRlbGV0ZVNldERyZXNzaW5nUmVmZXJlbmNlUmVzcG9uc2USUgoGcmVzdWx0GAEgASgLMkIucHJvdG9zLnZpc2lvbi5hc3NldHMudjEuRGVsZXRlU2V0RHJlc3NpbmdSZWZlcmVuY2VSZXNwb25zZS5SZXN1bHQaCAoGUmVzdWx0YgZwcm90bzM");

/**
 * @generated from message protos.vision.assets.v1.DeleteSetDressingReferenceRequest
 */
export type DeleteSetDressingReferenceRequest = Message<"protos.vision.assets.v1.DeleteSetDressingReferenceRequest"> & {
  /**
   * @generated from field: protos.vision.assets.v1.DeleteSetDressingReferenceRequest.Params params = 1;
   */
  params?: DeleteSetDressingReferenceRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.DeleteSetDressingReferenceRequest.
 * Use `create(DeleteSetDressingReferenceRequestSchema)` to create a new message.
 */
export const DeleteSetDressingReferenceRequestSchema: GenMessage<DeleteSetDressingReferenceRequest> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_delete_set_dressing_reference, 0);

/**
 * @generated from message protos.vision.assets.v1.DeleteSetDressingReferenceRequest.Params
 */
export type DeleteSetDressingReferenceRequest_Params = Message<"protos.vision.assets.v1.DeleteSetDressingReferenceRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string asset_id = 2;
   */
  assetId: string;
};

/**
 * Describes the message protos.vision.assets.v1.DeleteSetDressingReferenceRequest.Params.
 * Use `create(DeleteSetDressingReferenceRequest_ParamsSchema)` to create a new message.
 */
export const DeleteSetDressingReferenceRequest_ParamsSchema: GenMessage<DeleteSetDressingReferenceRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_delete_set_dressing_reference, 0, 0);

/**
 * @generated from message protos.vision.assets.v1.DeleteSetDressingReferenceResponse
 */
export type DeleteSetDressingReferenceResponse = Message<"protos.vision.assets.v1.DeleteSetDressingReferenceResponse"> & {
  /**
   * @generated from field: protos.vision.assets.v1.DeleteSetDressingReferenceResponse.Result result = 1;
   */
  result?: DeleteSetDressingReferenceResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.assets.v1.DeleteSetDressingReferenceResponse.
 * Use `create(DeleteSetDressingReferenceResponseSchema)` to create a new message.
 */
export const DeleteSetDressingReferenceResponseSchema: GenMessage<DeleteSetDressingReferenceResponse> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_delete_set_dressing_reference, 1);

/**
 * @generated from message protos.vision.assets.v1.DeleteSetDressingReferenceResponse.Result
 */
export type DeleteSetDressingReferenceResponse_Result = Message<"protos.vision.assets.v1.DeleteSetDressingReferenceResponse.Result"> & {
};

/**
 * Describes the message protos.vision.assets.v1.DeleteSetDressingReferenceResponse.Result.
 * Use `create(DeleteSetDressingReferenceResponse_ResultSchema)` to create a new message.
 */
export const DeleteSetDressingReferenceResponse_ResultSchema: GenMessage<DeleteSetDressingReferenceResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_assets_v1_delete_set_dressing_reference, 1, 0);

